import React from 'react';

import { GUID } from '@ndvr/auth-api';
import { Account } from '@ndvr/portfolio-api';

import { Spinner, VerticalLayout } from 'widgets';

import { useAccount } from '../account-queries';

export const AccountSummary = ({ accountGUID }: { accountGUID: GUID<Account> }) => {
    const { data: account, isLoading } = useAccount(accountGUID);

    if (isLoading) {
        return <Spinner size="large" />;
    }
    if (!account) {
        return `Not found Account=${accountGUID}`;
    }

    return <VerticalLayout>{account.accountName.plainText}</VerticalLayout>;
};
